export default __webpack_public_path__ + "static/media/planning-zoning.ea2bc9b3.svg";